// extracted by mini-css-extract-plugin
export default {"content":"sidebarLayout_content__-YKyu"};